import axios from "axios";
import StorageService from "../storage/StorageService";

import CookieUtil from "../../utils/cookie/CookieUtil";

const url = '/api/cdk/admin/v1/system-messages/';

const SystemMessageService = {

    getMessage: async () => {

        // Remove old items
        StorageService.removeExpiredItems().then();

        // Fetch the message
        const systemMessage = (await axios.get(`${url}`)).data;
        const user = CookieUtil.getUser();

        if(systemMessage && systemMessage.message) {
            if(!StorageService.getItem(createStorageKey(systemMessage.id, user))) {
                return {
                    hasMessage: true,
                    ...systemMessage
                }
            }
        }

        return {hasMessage: false}

    },
    doNotShowMessageAgain: async (messageId) => {
        const user = CookieUtil.getUser();
        StorageService.addItem(createStorageKey(messageId, user), true,60 * 24);
    }

}

const createStorageKey = (messageId, user) => `${messageId}_${user}`;

export default SystemMessageService;